import React from 'react';
import type {CheckoutBrandModel} from '../../../domain/models/common/CheckoutBrand.model';
import {getBackgroundPalette} from '../../../domain/models/common/backgroundPalette';
import {hexToRgbString} from '../../../domain/utils/colors';

export function getBrandStyle(checkoutBrand?: CheckoutBrandModel): React.CSSProperties {
  const formBackgroundColor = hexToRgbString(checkoutBrand?.formSection?.backgroundColor);
  const formTextColor = hexToRgbString(checkoutBrand?.formSection?.textColor);
  const formSecondaryTextColor = hexToRgbString(checkoutBrand?.formSection?.secondaryTextColor);
  const selectionColor = hexToRgbString(checkoutBrand?.global?.selectionColor);
  const tintedBoxColor = hexToRgbString(checkoutBrand?.global?.tintedBoxColor);
  const tintedBoxTextColor = hexToRgbString(checkoutBrand?.global?.tintedBoxTextColor);
  const summaryTextColor = hexToRgbString(checkoutBrand?.summarySection?.textColor);
  const buttonColor = hexToRgbString(checkoutBrand?.global?.buttonColor);
  const cornerRadius = checkoutBrand?.global?.cornerRadius;
  const cornerRadiusValue = typeof cornerRadius === 'number' ? `${cornerRadius}` : undefined;
  const selectionTextColor = hexToRgbString(getBackgroundPalette(checkoutBrand?.global?.selectionColor)?.textColor);

  return {
    '--headerBackground': checkoutBrand?.header?.backgroundFill?.color,
    '--headerTextColor-rgb': hexToRgbString(checkoutBrand?.header?.textColor),
    '--checkoutButtonColor': buttonColor,
    '--checkoutPlaceOrderButtonColor': hexToRgbString(checkoutBrand?.global?.placeOrderButtonColor),
    '--checkoutFormBackgroundColor': formBackgroundColor,
    '--checkoutSummaryBackgroundColor': hexToRgbString(checkoutBrand?.summarySection?.backgroundColor),
    '--checkoutButtonTextColor': hexToRgbString(checkoutBrand?.global?.buttonTextColor),
    '--checkoutPlaceOrderButtonTextColor': hexToRgbString(checkoutBrand?.global?.placeOrderButtonTextColor),
    '--checkoutFormTextColor': formTextColor,
    '--checkoutSummaryTextColor': summaryTextColor,
    '--checkoutFormSecondaryButtonTextColor': buttonColor ? formTextColor : undefined,
    '--checkoutSummarySecondaryButtonTextColor': buttonColor ? summaryTextColor : undefined,
    '--checkoutFormSecondaryTextColor': formSecondaryTextColor,
    '--checkoutSummarySecondaryTextColor': hexToRgbString(checkoutBrand?.summarySection?.secondaryTextColor),
    '--checkoutFooterBackgroundColor': hexToRgbString(checkoutBrand?.footer?.backgroundColor),
    '--checkoutFooterTextColor': hexToRgbString(checkoutBrand?.footer?.textColor),
    '--checkoutHeaderDividerColor': hexToRgbString(checkoutBrand?.header?.dividerColor),
    '--checkoutFooterDividerColor': hexToRgbString(checkoutBrand?.footer?.dividerColor),
    '--checkoutMainDividerColor': hexToRgbString(checkoutBrand?.mainDividerColor),
    '--checkoutTintedBoxColor': tintedBoxColor,
    '--checkoutTintedBoxTextColor': tintedBoxTextColor,
    '--deliveryMethodsTintedBoxOpacity': tintedBoxColor ? '1' : undefined,
    '--checkoutSelectionColor': selectionColor,
    '--deliveryMethodsBackgroundColor': formBackgroundColor,
    '--deliveryMethodsTextColor': formTextColor,
    '--deliveryMethodsSecondaryTextColor': formSecondaryTextColor,
    '--deliveryMethodsSelectionColor': selectionColor,
    '--deliveryMethodsTintedBoxColor': tintedBoxColor,
    '--deliveryMethodsTintedBoxTextColor': tintedBoxTextColor,
    '--deliveryMethodsSelectionTextColor': selectionTextColor,
    '--checkoutCornerRadius': cornerRadiusValue,
    '--deliveryMethodsCornerRadius': cornerRadiusValue,
    '--payments-co-border-radius': cornerRadiusValue,
    '--payments-ecw-background-color': formBackgroundColor,
    '--payments-ecw-text-color': formTextColor,
    '--payments-ecw-divider-color': hexToRgbString(checkoutBrand?.formSection?.expressButtonsBorderColor),
    '--payments-ecw-border-radius': cornerRadiusValue,
    '--payments-co-background-color': formBackgroundColor,
    '--payments-co-text-color': formTextColor,
    '--payments-co-method-box-background-color': tintedBoxColor,
    '--payments-co-method-box-text-color': tintedBoxTextColor,
    '--payments-co-method-box-icon-color': tintedBoxTextColor,
    '--payments-co-method-box-opacity': tintedBoxColor ? '1' : undefined,
    '--payments-co-method-box-border-radius': cornerRadiusValue,
    '--payments-co-cta-color': hexToRgbString(checkoutBrand?.global?.selectionColor),
  } as React.CSSProperties;
}
